// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F1ul","col":"styles_col__22n6H"};